import { Progress } from '@chakra-ui/react';
import { MBox } from '../../../components/Monetize';

interface BillingPageLoadingBarProps {
  isVisible: boolean;
  progress: number;
}

export const BillingPageLoadingBar = ({
  isVisible = false,
  progress,
}: BillingPageLoadingBarProps) => {
  return (
    <MBox minH="4px" width="100%" mt="-6" mb="6">
      {isVisible && (
        <Progress.Root
          width="100%"
          size="2xs"
          value={progress}
          variant="neutral"
        >
          <Progress.Track>
            <Progress.Range />
          </Progress.Track>
        </Progress.Root>
      )}
    </MBox>
  );
};
